module.exports = __webpack_public_path__ + "img/glazing-triple.d2f2987.svg";